import { render } from "./ScreenHeader.vue?vue&type=template&id=c0625368&scoped=true"
import script from "./ScreenHeader.vue?vue&type=script&lang=js"
export * from "./ScreenHeader.vue?vue&type=script&lang=js"

import "./ScreenHeader.vue?vue&type=style&index=0&id=c0625368&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0625368"]])

export default __exports__